import React, { useState, useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import debounce from 'lodash/debounce'
import { Box } from '@mui/material'
import classNames from 'classnames'
import screen1 from 'assets/topbar/choose_your_focus.png'
import screen1Selected from 'assets/topbar/tb_choose.png'
import screen2 from 'assets/topbar/earnings.png'
import screen2Selected from 'assets/topbar/tb_demo.png'
import screen3 from 'assets/topbar/environment_crime.png'
import screen3Selected from 'assets/topbar/tb_edu.png'
import screen4 from 'assets/topbar/educational_attainment.png'
import screen4Selected from 'assets/topbar/tb_income.png'
import screen5 from 'assets/topbar/tb6_college_going.png'
import screen5Selected from 'assets/topbar/tb_hsgradrates.png'
import screen6 from 'assets/topbar/HSgraduation_college_going.png'
import screen6Selected from 'assets/topbar/tb_hsinter.png'
import screen7 from 'assets/topbar/tb7_interventions.png'
import screen7Selected from 'assets/topbar/tb_envirnment.png'
import useStyles from '../styles'

const SCREENS = [
    {
        title: 'Screen 1',
        icon: screen1,
        selectedIcon: screen1Selected,
    },
    {
        title: 'Screen 2',
        icon: screen2,
        selectedIcon: screen2Selected,
    },
    {
        title: 'Screen 3',
        icon: screen3,
        selectedIcon: screen4Selected,
    },
    {
        title: 'Screen 4',
        icon: screen4,
        selectedIcon: screen3Selected,
    },
    {
        title: 'Screen 5',
        icon: screen5,
        selectedIcon: screen5Selected,
    },
    {
        title: 'Screen 6',
        icon: screen6,
        selectedIcon: screen6Selected,
    },
    {
        title: 'Screen 7',
        icon: screen7,
        selectedIcon: screen7Selected,
    },
]

const TopbarContent = ({ onClose }) => {
    const classes = useStyles()
    const [screen, setScreen] = useState(1)
    const { isHorizontal } = useSelector((state) => state.app)

    const getCurrentScreen = useCallback(() => {
        const x = window.pageXOffset
        const y = window.pageYOffset
        const screen = isHorizontal
            ? Math.round(x / 1920) + 1
            : Math.round(y / 1080) + 1
        setScreen(screen)
    }, [isHorizontal])

    const scrollToTab = (tab) => {
        window.scroll({
            top: isHorizontal ? 0 : tab * 1080,
            left: isHorizontal ? tab * 1920 : 0,
            behavior: 'smooth',
        })
        onClose()
    }

    useEffect(() => {
        const debouncedGetCurrentScreen = debounce(getCurrentScreen, 200)
        window.addEventListener('scroll', debouncedGetCurrentScreen)

        // Initial screen check
        getCurrentScreen()

        return () => {
            window.removeEventListener('scroll', debouncedGetCurrentScreen)
        }
    }, [getCurrentScreen])

    return (
        <Box className={classes.contentWrapper}>
            <Box className={classes.items}>
                {SCREENS.map((s, i) => {
                    const selected = screen === i + 1
                    return (
                        <div
                            key={i}
                            className={classNames(classes.item, {
                                [classes.selected]: selected,
                            })}
                            onClick={() => scrollToTab(i)}
                        >
                            <img
                                className={classes.media}
                                alt={s.title}
                                src={selected ? s.selectedIcon : s.icon}
                            />
                            {s.title}
                        </div>
                    )
                })}
            </Box>
        </Box>
    )
}

export default TopbarContent
